import { render, staticRenderFns } from "./IconLabel.vue?vue&type=template&id=3201ea66&scoped=true"
import script from "./IconLabel.vue?vue&type=script&lang=js"
export * from "./IconLabel.vue?vue&type=script&lang=js"
import style0 from "./IconLabel.vue?vue&type=style&index=0&id=3201ea66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201ea66",
  null
  
)

export default component.exports